<template>
    <div style="max-height: 500px;overflow-y: auto">
      <div v-if="childData.length === 0" style="height: 200px;line-height: 200px;font-size: 24px;color: #666666;text-align: center;">
        <span>暂无子机</span>
      </div>
      <div style="height: 40px;" v-else>
        <input placeholder="输入关键字搜索" class="search-inpt"/>
      </div>
      <div class="card-list-blue" v-for="item in childData" :key="item.index">
        <div class="img-left">
          <img :src="getImgUrl(item.sub_type)">
        </div>
        <div class="body-center">
          <div style="height: 100px">
            <div style="height: 10px"></div>
            <div style="height: 22px;font-size: 18px;">
              <span style="color: #00ccff">{{item.sub_name}}</span>
            </div>
            <div v-if="$store.state.user.moduletag === 2 && item.bid !== 0" style="height: 20px;font-size: 12px;line-height: 20px;color: #666666">
              <span style="font-size: 14px">{{item.bed_remark_name}}</span>
              <span> - {{item.install_location}}</span>
            </div>
            <div v-if="$store.state.user.moduletag !== 2 && item.pid !== 0" style="height: 20px;font-size: 12px;line-height: 20px;color: #666666">
              <span style="font-size: 14px">分配老人：{{item.person_name}}</span>
            </div>
            <div style="height: 10px" v-else></div>
            <div style="height: 20px;color: #666666">
                  <span>
                    <img style="vertical-align: text-top;" src="../../../../static/subDevice/son_icon_imei.png">
                    <span>{{item.sub_deviceid}}</span>
                  </span>
              <span style="margin-left: 40px">
                    <img style="vertical-align: text-top;" src="../../../../static/subDevice/son_icon_type.png">
                    <span>{{getChildDtpye(item.sub_type)}}</span>
                  </span>
            </div>
            <div style="height: 20px;color: #666666">
                   <span>
                    <img style="vertical-align: text-top;" src="../../../../static/subDevice/son_icon_time.png">
                    <span>{{item.hearttime}}</span>
                  </span>&nbsp;&nbsp;&nbsp;
              <span v-if="(item.config.temperature || item.config.temperature === 0)">
                        <img src="../../../../static/subDevice/son_icon_temperature.png"/>
                        {{item.config.temperature}}℃&nbsp;&nbsp;&nbsp;</span>
              <span v-if="(item.config.humidity || item.config.humidity === 0)">
                        <img src="../../../../static/subDevice/son_icon_humidity.png"/>
                        {{item.config.humidity}}%&nbsp;&nbsp;&nbsp;</span>
              <span v-if="(item.config.voltage || item.config.voltage === 0)">
                          <img src="../../../../static/subDevice/son_icon_electricity.png"/>
                          <span v-if="item.config.voltage > 100">{{item.config.voltage / 100}}V</span>
                          <span v-else>{{item.config.voltage}}V</span>&nbsp;&nbsp;&nbsp;</span>
              <span v-if="(item.config.pressure || item.config.pressure === 0)">
                          <img src="../../../../static/subDevice/son_icon_water_pressure.png"/>
                        {{getMPaName(item.config.pressure)}}MPa&nbsp;&nbsp;&nbsp;</span>
              <span v-if="(item.config.level || item.config.level === 0)">
                          <img src="../../../../static/subDevice/son_icon_water_level.png"/>
                        {{getLevelName(item.config.level)}}M</span>
            </div>
          </div>
          <div class="socket-icon" v-if="item.sub_type === 51">
            <img src="../../../../static/subDevice/son_socket_switch_up.png">
          </div>
        </div>
        <div class="btn-right" v-if="$store.state.user.moduletag !== 2">
          <el-row>
            <el-col :span="12"  v-if="item.sub_type === 32 || item.sub_type === 30">
              <!--      睡眠带绑定人        -->
              <div  v-if="item.pid === 0" class="sub-yellow" @click="bindSubDeviceOpen(item)">
                <span>分配老人</span>
              </div>
              <div style="margin-top: 15px" v-else class="sub-gray" @click="unbindSub(item)">
                <span>解除绑定</span>
              </div>
              <div class="sub-blue" @click="setSub(item)">
                <span>睡眠设置</span>
              </div>
            </el-col>
            <el-col :span="12"  v-else>&nbsp;</el-col>
            <el-col :span="12">
              <div class="edit-sub-blue1" @click="editSub(item)">
                <span>编辑</span>
              </div>
              <div class="del-sub-red1" @click="delSub(item)">
                <span>删除</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="btn-right" v-else>
          <el-row>
            <el-col :span="12"  v-if="item.sub_type === 30 || item.sub_type === 31 || item.sub_type === 32 || item.sub_type === 16">
            <!--      睡眠带，睡眠床垫，血压计,SOS拉绳报警器        -->
              <div v-if="item.bid === 0" class="sub-yellow" @click="bindSubDeviceOpen(item)">
                <span>分配位置</span>
              </div>
              <div v-else style="height: 5px"></div>
              <div v-if="item.bid !== 0" class="sub-gray" @click="unbindSub(item)">
                <span>解除绑定</span>
              </div>
              <div class="sub-blue" @click="setSub(item)" v-if="item.sub_type === 30 || item.sub_type === 32">
                <span>睡眠设置</span>
              </div>
            </el-col>
            <el-col :span="12"  v-else>&nbsp;</el-col>
            <el-col :span="12">
              <div class="edit-sub-blue1" @click="editSub(item)">
                <span>编辑</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <el-dialog :visible.sync="addSubShow" v-if="addSubShow" width="500px"
        :show-close="true" :close-on-click-modal="false"
        center append-to-body class="all-open">
        <div class="title-top-alarm">
          <div>
            <span>{{titleShow}}</span>
          </div>
          <div class="line-title"></div>
        </div>
        <add-edit-sub-device :mainDevice="subObj" v-model="addSubShow"></add-edit-sub-device>
      </el-dialog>
      <!--  分配老人  -->
      <el-dialog :visible.sync="subShow" v-if="subShow" width="500px"
                 :show-close="true" :close-on-click-modal="false"
                 center append-to-body class="all-open">
        <div class="title-top-alarm">
          <div v-if="$store.state.user.moduletag === 2"> <span>【{{subBedObj.subItem.sub_name}}】分配位置</span> </div>
          <div v-else> <span>【{{subBedObj.subItem.sub_name}}】分配老人</span> </div>
          <div class="line-title"></div>
        </div>
        <sub-device-bed :subBedObj="subBedObj" v-model="subShow"></sub-device-bed>
      </el-dialog>
      <!--  睡眠设置  -->
      <el-dialog :visible.sync="subShow1" v-if="subShow1" width="500px" :show-close="true" :close-on-click-modal="false" center append-to-body class="all-open">
        <div class="title-top-alarm">
          <div><span>睡眠设置</span></div>
          <div class="line-title"></div>
        </div>
        <set-sleep :sleepObj="subBedObj" v-model="subShow1"></set-sleep>
      </el-dialog>
    </div>
</template>

<script>
import {querysubdevice, deletesubdevice, unbindsubdevice} from '../../../api/device'
import addEditSubDevice from './addEditSubDevice'
import subDeviceBed from './subDeviceBed'
import setSleep from '../deviceComponents/setSleep.vue'
export default {
  name: 'subList',
  model: {
    prop: 'subShow',
    event: 'change'
  },
  props: {
    device: {
      type: Object
    }
  },
  components: {
    setSleep, addEditSubDevice, subDeviceBed
  },
  data () {
    return {
      imgSrc: [
        {dtype: -1, imgUrl: 'static/subDevice/son_alarmlamp.png'}, // 警灯
        {dtype: 1, imgUrl: 'static/subDevice/son_CO.png'}, // 一氧化碳
        {dtype: 2, imgUrl: 'static/subDevice/son_humidity_smoke.png'}, // 烟感
        {dtype: 3, imgUrl: 'static/subDevice/son_gas.png'}, // 燃气
        {dtype: 4, imgUrl: 'static/subDevice/son_door.png'}, // 门磁
        {dtype: 5, imgUrl: 'static/subDevice/son_doorbell.png'}, // 门铃
        {dtype: 6, imgUrl: 'static/subDevice/son_red.png'}, // 红外
        {dtype: 7, imgUrl: 'static/subDevice/son_water.png'}, // 水浸
        {dtype: 8, imgUrl: 'static/subDevice/son_control.png'}, // 遥控器
        {dtype: 11, imgUrl: 'static/subDevice/son_humidity_smoke.png'}, // 温湿度烟感
        {dtype: 12, imgUrl: 'static/subDevice/son_watergage.png'}, // 水压
        {dtype: 13, imgUrl: 'static/subDevice/son_level.png'}, // 水位
        {dtype: 14, imgUrl: 'static/subDevice/son_door.png'}, // 门磁
        {dtype: 51, imgUrl: 'static/subDevice/son_socket.png'}, // 智能开关
        {dtype: 52, imgUrl: 'static/subDevice/son_humiture.png'}, // 温湿度
        {dtype: 53, imgUrl: 'static/subDevice/son_lamp.png'}, // 智能灯泡
        {dtype: 30, imgUrl: 'static/subDevice/son_shuimiandai.png'}, // 睡眠带
        {dtype: 15, imgUrl: 'static/subDevice/son_leida.png'}, // 雷达
        {dtype: 31, imgUrl: 'static/subDevice/son_xueyaji.png'}, // 血压计
        {dtype: 32, imgUrl: 'static/subDevice/son_chuangdian.png'}, // 睡眠床垫
        {dtype: 16, imgUrl: 'static/subDevice/son_sos.png'}, // SOS拉绳报警器
        {dtype: '', imgUrl: 'static/subDevice/second_default.png'} // 默认
      ],
      childData: [],
      subObj: {
        device: '',
        row: ''
      },
      addSubShow: false,
      titleShow: '',
      subShow: false,
      subBedObj: {
        isMain: false,
        subList: [],
        subItem: '',
        device: ''
      },
      subShow1: false
    }
  },
  created () {
    this.golobleObject.addSubNew = this.getSubList
    this.subObj.device = this.device
    this.subBedObj.device = this.device
    // console.log(this.device)
  },
  mounted () {
    this.getSubList()
  },
  methods: {
    getSubList () {
      let data = {
        did: this.device.id
      }
      querysubdevice(data).then(res => {
        this.childData = res.data.subdevices
        let arr = []
        let obj = {
          show: false
        }
        for (let i = 0; i < res.data.subdevices.length; i++) {
          if (res.data.subdevices[i].bid === 0 && res.data.subdevices[i].sub_type === 30) {
            arr.push(res.data.subdevices[i])
          }
          if (res.data.subdevices[i].sub_type === 15) {
            obj.show = true
          }
        }
        this.subBedObj.subList = arr
        this.$emit('getDataEnd', obj)
      }).catch(() => {})
    },
    bindSubDeviceOpen (item) {
      this.subBedObj.subItem = item
      this.subShow = true
    },
    setSub (item) {
      this.subBedObj.subItem = item
      this.subShow1 = true
    },
    openSub () {
      this.subObj.row = ''
      this.titleShow = '添加子机'
      this.addSubShow = true
    },
    // 子设备对应icon
    getImgUrl (type) {
      let key = parseInt(type)
      let imgdata = this.imgSrc
      let aa = true
      for (let i = 0; i < imgdata.length; i++) {
        if (imgdata[i].dtype === key) {
          aa = false
          return imgdata[i].imgUrl
        }
      }
      if (aa) {
        return imgdata[this.imgSrc.length - 1].imgUrl
      }
    },
    getChildDtpye (dtype) {
      return this.commonType.getChildDtpye(dtype)
    },
    // 帕斯卡转兆帕
    getMPaName (pressure) {
      return pressure / 1000000
    },
    // 水位
    getLevelName (level) {
      return level / 100
    },
    editSub (item) {
      this.titleShow = '编辑子机'
      this.subObj.row = item
      this.addSubShow = true
    },
    delSub (item) {
      if (item.isonline === 1) {
        let name = item.sub_name
        this.$confirm('此操作将永久删除该子机设备【' + name + '】, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {}).catch(() => {})
      }
      let name = item.sub_name
      this.$confirm('此操作将永久删除该子机设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          subdeviceids: [item.id],
          imei: item.sub_deviceid
        }
        deletesubdevice(data).then(res => {
          this.$notify({
            title: '成功',
            message: '成功删除子机',
            type: 'success',
            duration: 2000
          })
          this.getSubList()
        }).catch(() => {})
      }).catch(() => {})
    },
    unbindSub (item) {
      let name = item.sub_name
      this.$confirm('此操作将解绑该子机设备【' + name + '】位置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          sub_deviceid: item.sub_deviceid,
          main_did: item.main_did,
          bind_type: 1,
          bid: item.bid,
          hid: item.hid
        }
        if (this.$store.state.user.moduletag === 2) {
          data = {
            sub_deviceid: item.sub_deviceid,
            main_did: item.main_did,
            bind_type: 1,
            bid: item.bid,
            hid: item.hid
          }
        } else {
          data = {
            'sub_deviceid': item.sub_deviceid,
            'main_did': item.main_did,
            'bind_type': 4,
            'pid': item.pid,
            'hid': item.p_hid
          }
        }
        unbindsubdevice(data).then(res => {
          this.$notify({
            title: '成功',
            message: '成功解绑',
            type: 'success',
            duration: 2000
          })
          this.getSubList()
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .search-inpt{
    padding-left: 10px;
    width: 200px;
    height: 30px;
    border-radius: 4px;
    border: solid 1px #1684fc;
    margin-left: 10px;
  }
  .add-sub{
    cursor: pointer;
    width: 151px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 22px;
    color: #ffffff;
    background-color: #17e6e6;
    border-radius: 20px;
    font-family: SourceHanSansCN-Regular;
  }
  .card-list-red{
    margin: 15px 20px;
    background: url("../../../../static/subDevice/son_bg_leave.png") no-repeat;
    background-size: 100% 100%;
    height: 100px;
  }
  .card-list-blue{
    margin: 10px;
    background-color: #f7fbff; /*红 #fff7f7*/
    box-shadow: 0px 5px 10px 1px
    rgba(4, 45, 89, 0.4);
    border-radius: 8px;
    height: 100px;
  }
  .img-left{
    float: left;
    height: 100%;
    width: 100px;
  }
  .img-left img{
    width: 60px;
    height: 60px;
    margin-left: 20px;
    margin-top: 20px;
  }
  .body-center{
    float: left;
    height: 100%;
    width: calc(100% - 280px);
  }
  .btn-right{
    float: right;
    height: 100%;
    width: 150px;
  }
  .del-edit-grey{
    margin-top: 35px;
    width: 100px;
    height: 30px;
    background-image: linear-gradient(0deg,
    #999999 0%,
    #b2b2b2 100%);
    border-radius: 15px;
  }
  .del-sub-red{
    cursor: pointer;
    margin-top: 10px;
    width: 100px;
    height: 30px;
    background-image: linear-gradient(0deg,
    #e52600 0%,
    #ff4a26 100%);
    border-radius: 15px;
  }
  .edit-sub-blue{
    cursor: pointer;
    margin-top: 15px;
    width: 100px;
    height: 30px;
    background-image: linear-gradient(0deg,
    #0099e5 0%,
    #26b7ff 100%);
    border-radius: 15px;
  }
  .del-sub-red1{
    cursor: pointer;
    margin-top: 10px;
    width: 60px;
    height: 30px;
    line-height: 30px;
    color: #FFFFFF;
    text-align: center;
    background-image: linear-gradient(0deg,
    #e52600 0%,
    #ff4a26 100%);
    border-radius: 15px;
  }
  .edit-sub-blue1{
    cursor: pointer;
    margin-top: 15px;
    width: 60px;
    height: 30px;
    line-height: 30px;
    color: #FFFFFF;
    text-align: center;
    background-image: linear-gradient(0deg,
    #0099e5 0%,
    #26b7ff 100%);
    border-radius: 15px;
  }
  .sub-yellow{
    cursor: pointer;
    margin-top: 15px;
    width: 70px;
    height: 30px;
    line-height: 30px;
    color: #FFFFFF;
    text-align: center;
    background-image: linear-gradient(0deg,
    #d9ba6c 0%,
    #e9be7d 100%);
    border-radius: 15px;
  }
  .sub-gray{
    cursor: pointer;
    margin-top: 10px;
    width: 70px;
    height: 30px;
    line-height: 30px;
    color: #FFFFFF;
    text-align: center;
    background-image: linear-gradient(0deg,
    #a59b9b 0%,
    #b4b1b1 100%);
    border-radius: 15px;
  }
  .sub-blue{
    cursor: pointer;
    margin-top: 10px;
    width: 70px;
    height: 30px;
    line-height: 30px;
    color: #FFFFFF;
    text-align: center;
    background-image: linear-gradient(0deg,
    #0099e5 0%,
    #26b7ff 100%);
    border-radius: 15px;
  }
  .socket-icon{
    width: 30px;
    height: 30px;
    margin: -65px auto 0;
  }
  .socket-icon img {
    width: 30px;
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/subList.vue